import { render } from "./ClientsShowCase.vue?vue&type=template&id=0f9a9bdd"
import script from "./ClientsShowCase.vue?vue&type=script&lang=js"
export * from "./ClientsShowCase.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "./ClientsShowCase.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__